module.exports = __webpack_public_path__ + "static/media/etsy-sketch.9184f7d9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/etsy-sketch.svg
// module id = 172
// module chunks = 0